import React, { useState, useEffect } from 'react';
import { useDispatch } from "react-redux";
import Form, { ButtonItem, ButtonOptions, GroupItem, Item, Label, RequiredRule, CheckBox } from "devextreme-react/form";
import Request from "../../components/Request/Request";
//import * as AppActions from '../../../actions/AppActions';
import { ToastType } from "../../constants/Constants";
import { showToast, parseDate, hasRole } from "../../utils/Utils";
import * as AppActions from '../../actions/AppActions';

const KazancDetay = (props) => {

    const dispatch = useDispatch();

    const [data, setData] = useState();

    const [storeGostergeTipi, setStoreGostergeTipi] = useState([]);

    useEffect(() => {
        getData();
        setStoreGostergeTipi([
            { id: 'UST_GOSTERGE', name: 'Üst Gösterge' },
            { id: 'ALT_GOSTERGE', name: 'Alt Gösterge' }
        ])
    }, [])

    const getData = () => {

        let id = -1;
        if (props.data && props.data.id) {
            id = props.data.id;
        } else {
            setData({});
            return;
        }
        const request = new Request("/emeklilik-app/api/kazanc-tanim/getKayit/" + id, "GET");
        dispatch(AppActions.setLoading(true, "Kayıt yükleniyor.."));
        return request.run()
            .then(response => {
                setData(response.data.data);
                dispatch(AppActions.setLoading(false, ""));
            });
    }
    function kaydet(e) {

        let eksikBilgi = false;
        e.validationGroup.validators.map((a) => {
            if (a.validate().status !== "valid") {
                eksikBilgi = true;
            }
        }
        );
        if (eksikBilgi) {
            showToast('Zorunlu alanları kontrol ediniz', ToastType.ERROR, 500);
            return;
        }

        let formData = data;

        let method = "POST"
        let url = "/emeklilik-app/api/kazanc-tanim/save";

        const request = new Request(url, method, formData);
        dispatch(AppActions.setLoading(true, "Kayıt işlemi yapılıyor.."));
        return request.run()
            .then(response => {
                dispatch(AppActions.setLoading(false, ""));
                if (response.data && response.data.data) {
                    props.hide();
                }
            });


    }

    const onTufeValueChanged = (e) => {

        let tufe = 0;
        let gelismeHizi = 0;
        if (data.tufe && data.tufe > 0) {
            tufe = data.tufe
        }
        if (data.gelismeHizi && data.gelismeHizi > 0) {
            gelismeHizi = data.gelismeHizi
        }

        let guncelKatsayi = ((tufe + (0.3 * gelismeHizi)) / 100) + 1;
        guncelKatsayi = guncelKatsayi.toFixed(4);
        setData(Object.assign({}, data, { guncelKatsayi: guncelKatsayi }));
    }

    return (
        <div >
            <Form formData={data} colCount={1} id="form" labelLocation={"left"} className="option" >

                <Item disabled={false} dataField={'name'} editorType={'dxTextBox'}
                    editorOptions={{}}>
                    <RequiredRule message="Adı bilgisi gerekli" />
                    <Label text='Adı' />
                </Item>
                <Item disabled={false} dataField={'yil'} editorType={'dxNumberBox'}
                    editorOptions={{
                        showSpinButtons: true,
                        showClearButton: false,
                        min: 2008,
                        max: 2050
                    }}>
                    <RequiredRule message="Yıl bilgisi gerekli" />
                    <Label text='Yıl' />
                </Item>
                <Item disabled={false} dataField={'tufe'} editorType={'dxNumberBox'}
                    editorOptions={{
                        showSpinButtons: false,
                        showClearButton: false,
                        onValueChanged: onTufeValueChanged
                    }}>
                    <RequiredRule message="Tüfe bilgisi gerekli" />
                    <Label text='Tüfe' />
                </Item>
                <Item disabled={false} dataField={'gelismeHizi'} editorType={'dxNumberBox'}
                    editorOptions={{
                        showSpinButtons: false,
                        showClearButton: false,
                        onValueChanged: onTufeValueChanged
                    }}>
                    <RequiredRule message="Gelişme Hızı bilgisi gerekli" />
                    <Label text='Gelişme Hızı ' />
                </Item>
                <Item disabled={false} dataField={'guncelKatsayi'} editorType={'dxNumberBox'}
                    editorOptions={{
                        showSpinButtons: false,
                        showClearButton: false
                    }}>
                    <RequiredRule message="Güncel Katsayı bilgisi gerekli" />
                    <Label text='Güncel Katsayı' />
                </Item>


                <ButtonItem>
                    <ButtonOptions
                        onClick={(e) => { kaydet(e); }}
                        width={'100%'}
                        type={'success'}
                        useSubmitBehavior={true}>
                        <span className="dx-button-text">
                            {'Kaydet'
                            }
                        </span>
                    </ButtonOptions>
                </ButtonItem>

            </Form>


        </div>
    )
}

export default KazancDetay;
